import camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import pickBy from 'lodash/pickBy';

const startsWithData = (val, key) => key.startsWith('data-');
const stripDataPrefix = cur => cur.split('data-')[1];

export default function getDatasetFromProps(props) {
  const dataProps = pickBy(props, startsWithData);
  return mapKeys(dataProps, (val, key) => camelCase(stripDataPrefix(key)));
}
